import { RootState } from 'app/store/rootReducer';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPosts, getMorePostsSuccess, getPostsFailure, } from '../posts/postsListSlice';
import PostVideoItem from 'features/posts/postVideoItem';
import AdSense from 'components/AdSense';
import { SEO } from 'components/SEO';
import {
  Row,
  Input
} from 'reactstrap';
import { getPosts, processPosts } from 'services/posts-service';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from 'helpers/authContext';
import { setSteemConfig } from 'config';
import { custom_post_queue, get_plans, get_views, top_posts_alltime, top_posts_latest } from 'services/db-service';
import { getCommunity } from 'services/community-service';
import SubscribeButton from 'components/SubscribeButton';
import LoginModal from 'features/user/userModals/LoginModal';
import useModal from 'helpers/useModal';
import ContentCreatePostModal from "features/content/contentModals/ContentCreatePostModal";
import { CommunityInfoModal } from './CommunityInfoModal';
import { numberWithCommas } from 'services/dsteem-service';
import Skeleton from 'react-loading-skeleton';
import { ClaimRewardBanner } from '../leaderboard/ClaimRewardBanner';

const PREDEFINED_TAGS = ['steemvideo', 'video', 'vlog', 'youtube'];

export const MainPage = (params: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let activeCategory = params.activeCategory;
  let { tag } = useParams<{ tag?: string }>();
  tag = tag ? tag : "steemvideo";
  const { isOpenLoginModal, toggleLoginModal,
    isOpenContentCreatePostModal, toggleContentCreatePostModal,
    isOpenCommunityInfoModal, toggleCommunityInfoModal } = useModal();
  // const {  } = useModal(); 
  const [activeTab, setActiveTab] = React.useState(params.activeCategory || (tag === "steemvideo" ? "foryou" : "created"));
  const [loadingMore, setLoadingMore] = useState(false);
  const observer = useRef<IntersectionObserver | null>(null);
  const {
    displayablePosts,
    isLoading,
    error,
    hasMore,
    currentFilter,
    currentTag
  } = useSelector((state: RootState) => state.posts);
  const posts = displayablePosts;
  const [filter, setFilter] = useState(
    params.activeCategory || activeCategory || (tag === "steemvideo" ? "foryou" : "created")
  );
  const [limit, setLimit] = useState(20);
  const [startFrom, setStartFrom] = useState(20);
  const [userPlans, setUserPlans] = useState([]);
  const [customTag, setCustomTag] = useState(tag || PREDEFINED_TAGS[0]);
  const [inputTag, setInputTag] = useState('');
  const [showInputTag,
    //setshowInputTag
  ] = useState(false);
  const [views, setViews] = useState([]);
  const [community, setCommunity] = useState<any>();
  const [userRole, setUserRole] = useState("guest");
  const { lastAuthor, lastPermlink } = useSelector((state: RootState) => state.posts);
  const { user, rpc_node } = useAuth();

  useEffect(() => {
    if (tag) {
      setCustomTag(tag);
    }
  }, [tag]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        sessionStorage.setItem('mainPage_scroll', window.scrollY.toString());
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!isLoading && posts.length > 0) {
      const savedScroll = sessionStorage.getItem('mainPage_scroll');
      if (savedScroll) {
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedScroll));
        }, 100);
      }
    }
  }, [isLoading, posts.length]);

  if (activeCategory == "feed") {
    return (
      <div className="text-center">
        This page is not ready yet
      </div>
    );
  }
  const loadMorePosts = useCallback(async () => {
    if (!hasMore || posts.length === 0) return;

    setLoadingMore(true);

    try {
      if (filter == "top" || filter == "alltime") {
        console.log("loading more from the db", startFrom);
        let video_posts = [];
        try {
          if (filter == "top") {
            video_posts = (await top_posts_latest(limit, startFrom)) || [];
          } else {
            video_posts = (await top_posts_alltime(limit, startFrom)) || [];
          }
        } catch (error) {
          console.log(error);
        }

        if (video_posts != undefined && video_posts.length > 0) {
          video_posts = processPosts(video_posts);
          const newPosts = video_posts.filter(newPost =>
            !posts.some(existingPost =>
              existingPost.author === newPost.author && existingPost.permlink === newPost.permlink
            )
          );

          const updatedPosts = [...posts, ...newPosts];
          console.log(updatedPosts);

          let hasMoreNew = false;
          if (video_posts.length >= limit) {
            hasMoreNew = true;
            setStartFrom(updatedPosts.length);
          }
          dispatch(getMorePostsSuccess({ posts: newPosts, hasMore: hasMoreNew, lastAuthor: '', lastPermlink: '' }));
        }
      } else if (filter === "foryou") {
        const start = posts.length;
        const video_posts = await custom_post_queue(user, limit, start);
        
        if (video_posts && video_posts.length > 0) {
           const processed = processPosts(video_posts);
           const newPosts = processed.filter(newPost =>
            !posts.some(existingPost =>
              existingPost.author === newPost.author && existingPost.permlink === newPost.permlink
            )
          );
          const hasMoreNew = video_posts.length >= limit;
          dispatch(getMorePostsSuccess({ posts: newPosts, hasMore: hasMoreNew, lastAuthor: '', lastPermlink: '' }));
        }
      } else {
        const newPostsData = await getPosts(limit, customTag, filter, false, lastAuthor, lastPermlink, 'get_ranked_posts', tag ? false : true);

        const newPosts = newPostsData.posts.filter(newPost =>
          !posts.some(existingPost =>
            existingPost.author === newPost.author && existingPost.permlink === newPost.permlink
          )
        );

        // const updatedPosts = [...posts, ...newPosts];
        const hasMoreNew = newPostsData.hasMore;

        // dispatch(getMorePostsSuccess({ posts: updatedPosts, hasMore: hasMoreNew }));
        dispatch(getMorePostsSuccess({ posts: newPosts, hasMore: hasMoreNew }));
      }
    } catch (err) {
      console.log('error getting', err);
      dispatch(getPostsFailure(err.toString()));
    }

    setLoadingMore(false);
  }, [dispatch, filter, limit, posts, hasMore, customTag]);

  const lastPostElementRef = useCallback((node) => {

    if (loadingMore) { return; }
    if (observer.current) {
      observer.current.disconnect();
    }
    observer.current = new IntersectionObserver(entries => {

      if (entries[0].isIntersecting && hasMore) {
        console.log('last element visible, loading more...');
        loadMorePosts();
      }
    }, {
      threshold: 0.1
    });
    if (node) observer.current.observe(node);
  }, [loadingMore, hasMore, loadMorePosts]);

  const handleInputTagChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputTag(e.target.value);
  };

  const handleCustomTagSubmit = () => {
    const formatted = inputTag.toLowerCase().trim();
    if (formatted) {
      setCustomTag(formatted);
    }
  };
  useEffect(() => {
    const getViews = async () => {
      let data = await get_views();
      setViews(data);
    }
    getViews();
    const getPlans = async () => {
      let data = await get_plans();
      setUserPlans(data);
    }
    getPlans();
    const getCommunityData = async () => {

      let data: any = await getCommunity(tag, user ? user : "");

      if (data) {
        setCommunity(data);
        if (data.context && data.context.role) {
          setUserRole(data.context.role);
        }
      } else {
        console.log("No community");
        setCommunity(null);
      }
    }
    getCommunityData();
  }, [tag]);
  useEffect(() => {
    const fetchData = async () => {
      setSteemConfig(rpc_node);

      if (posts.length > 0 && currentFilter === filter && currentTag === customTag) {
        console.log("Posts already loaded, skipping fetch");
        return;
      }

      dispatch(fetchPosts(customTag, filter, true, true, limit, tag ? false : true, user));
      setLimit(20);
    };
    if (community) {
      let path;
      let f;
      if (activeCategory == "top") {
        path = `/top`;
        f = "top";
        setCommunity(null);
      } else {
        if (activeTab === "created") {
          path = `/new/${tag}`;
          f = activeTab;
        } else if (activeTab === "trending") {
          path = `/trending/${tag}`;
          f = activeTab;
        } else if (activeTab === "muted") {
          path = `/muted/${tag}`;
          f = activeTab;
        } else if (activeTab === "top") {
          path = `/top`;
          f = activeTab;
        } else if (activeTab === "alltime") {
          path = `/top/alltime`;
          f = activeTab;
        } else {
          f = "created";
          path = `/new/${tag}`;
        }
      }

      navigate(path, { replace: true });
      if (filter == f) { // doouble check the filter to avoid querying twice
        console.log("Fetching", customTag, filter);
        fetchData();
      }

    } else {
      fetchData();
    }
  }, [activeTab, filter, customTag, tag, community]);
  useEffect(() => {
    if (params.activeCategory) {
      setFilter(params.activeCategory);
    }
  }, [params.activeCategory]);

  let communityHeader;
  let communityCover;

  if (community) {
    if (community.settings && community.settings.cover_url) {
      communityCover = (
        <div className="cover-container" style={{ width: "100%", height: "220px", overflow: "hidden", borderRadius: "12px 12px 0 0" }}>
          <img src={community.settings.cover_url} alt='Cover' className='profile-cover' style={{ display: "block" }} />
          <div className="profile-cover-gradient"></div>
          <div className="profile-floating-buttons">
            <SubscribeButton community={community} onLogin={toggleLoginModal} className='mr-2 mb-2' />
            <button
              className={`action-button mr-2 mb-2`}
              onClick={toggleContentCreatePostModal}
            // style={{minWidth:"127px"}}
            >
              New Post
            </button>
            <div className="d-inline-block mb-2">
              <button className="btn btn-default" onClick={toggleCommunityInfoModal}>
                <i className="fas fa-info" />
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      communityCover = (
        <div className="cover-container" style={{ width: "100%", height: "220px", overflow: "hidden", borderRadius: "12px 12px 0 0" }}>
          {/* <img src={profile.cover_image} alt='Cover' className='profile-cover' style={{ display: "block" }} /> */}
          {/* <div className="profile-cover-gradient"></div> */}
          <div className="profile-floating-buttons">
            <SubscribeButton community={community} onLogin={toggleLoginModal} className='mr-2 mb-2' />
            <button
              className={`action-button mr-2 mb-2`}
              onClick={toggleContentCreatePostModal}
            // style={{minWidth:"127px"}}
            >
              New Post
            </button>
            <div className="d-inline-block mb-2">
              <button className="btn btn-default" onClick={toggleCommunityInfoModal}>
                <i className="fas fa-info" />
              </button>
            </div>
          </div>
        </div>
      );
    }
    communityHeader = (
      <>
        <div className="card-stats card item-speem mb-2" style={{ overflow: "hidden" }}>
          {communityCover && communityCover}
          <div className="card-body pb-0" style={{ marginTop: "-125px" }}>
            <div className="row profile-container d-flex p-2">
              <div className="col-12 col-sm-12 col-md-3 col-lg-2 text-center text-sm-center text-md-left">
                <div className="profile-image-container">
                  <img
                    src={community.avatar_url || `https://steemitimages.com/u/${community.name}/avatar`}
                    alt="Profile"
                    className="profile-image"
                  />
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-9  col-lg-10 text-center text-sm-center text-md-left">
                <div className="d-inline-block">
                  <div className="d-flex mb-2">
                    <h3 className={`fw-bold me-3 m-0 ${(communityCover) ? "color-md-white" : ""}`}>{community.title}</h3>
                  </div>

                </div>
                <div className={`mb-2 fw-semibold ${(communityCover) ? "color-md-white" : ""}`}>
                  {community.about}
                </div>

                <div className=" mb-1">
                  <div className="row">
                    <div className="col-6 col-md-6 col-lg-3 mt-3 mt-lg-0">
                      <div className="card-stats border-radius-speem "
                        style={{
                          background: "var(--sky-blue)",
                        }}>
                        <div className="p-2 card-body">
                          <p className="text-uppercase w-100  m-0" style={{ color: "white", fontSize: "0.6rem" }}><i className="fas fa-user" /> Subscribers</p>
                          <span className="h2" style={{ color: "white" }}>{numberWithCommas(community.subscribers)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-md-6 col-lg-3 mt-3 mt-lg-0">
                      <div className="card-stats border-radius-speem"
                        style={{
                          background: "var(--wild-green)",
                        }}>
                        <div className="p-2 card-body">
                          <p className="text-uppercase w-100  m-0" style={{ color: "white", fontSize: "0.6rem" }}><i className="fas fa-pen" /> Active posters</p>
                          <span className="h2" style={{ color: "white" }}>{numberWithCommas(community.num_authors)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-md-6 col-lg-3 mt-3 mt-lg-0">
                      <div className="card-stats border-radius-speem "
                        style={{
                          background: "var(--savage-phoenix)",
                        }}>
                        <div className="p-2 card-body">
                          <p className="text-uppercase w-100  m-0" style={{ color: "white", fontSize: "0.6rem" }}><i className="fas fa-dollar" /> Pending rewards</p>
                          <span className="h2" style={{ color: "white" }}>{numberWithCommas(community.num_pending)}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-md-6 col-lg-3 mt-3 mt-lg-0">
                      <div className="card-stats border-radius-speem"
                        style={{
                          background: "var(--poison-purple)",
                        }}>
                        <div className="p-2 card-body">
                          <p className="text-uppercase w-100  m-0" style={{ color: "white", fontSize: "0.6rem" }}><i className="fas fa-language" /> Language</p>
                          <span className="h2 text-uppercase" style={{ color: "white" }}>{community.lang}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="p-0 mb-2">
          <div className="container-fluid p-0">
            <div className="col-12 p-0">
              <div className="menu-tabs">
                <button className={`tab-button ${activeTab === 'foryou' ? 'active' : ''}`} onClick={() => setActiveTab('foryou')} title="For You">
                  <i className="fas fa-magic" /> <span className="d-none d-md-inline ml-1">For You</span>
                </button>
                <button className={`tab-button ${activeTab === 'created' ? 'active' : ''}`} onClick={() => setActiveTab('created')} title="New">
                  <i className="fas fa-clock" /> <span className="d-none d-md-inline ml-1">New</span>
                </button>
                <button className={`tab-button ${activeTab === 'trending' ? 'active' : ''}`} onClick={() => setActiveTab('trending')} title="Trending">
                  <i className="fas fa-fire" /> <span className="d-none d-md-inline ml-1">Trending</span>
                </button>
                <button className={`tab-button ${activeTab === 'muted' ? 'active' : ''}`} onClick={() => setActiveTab('muted')} title="Muted">
                  <i className="fas fa-eye-slash" /> <span className="d-none d-md-inline ml-1">Muted</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else if (tag && tag.startsWith('hive-') && isLoading && !community) {
    communityHeader = (
      <div className="card-stats card item-speem mb-2">
        <div className="cover-container" style={{ width: "100%", height: "220px", overflow: "hidden" }}>
          <Skeleton height={220} width="100%" />
        </div>
        <div className="card-body pb-0" style={{ marginTop: "-125px", position: "relative", zIndex: 1 }}>
          <div className="row profile-container d-flex p-2">
            <div className="col-12 col-sm-12 col-md-3 col-lg-2 text-center text-sm-center text-md-left">
              <div className="profile-image-container" style={{ background: "transparent" }}>
                <Skeleton circle={true} height={120} width={120} />
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-9 col-lg-10 text-center text-sm-center text-md-left">
              <div className="d-inline-block">
                <Skeleton width={250} height={30} className="mb-2" />
              </div>
              <div>
                <Skeleton width="80%" height={20} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  let seoTitle = "Speak on Steem";
  let seoDescription = "Watch the latest and trending videos on Speak on Steem.";
  if (community) {
    seoTitle = `${community.title} - Speak on Steem`;
    seoDescription = community.about || seoDescription;
  } else if (activeTab) {
    let tabLabel = activeTab.charAt(0).toUpperCase() + activeTab.slice(1);
    seoTitle = `${tabLabel} - Speak on Steem`;
  }

  // if (isLoading && posts.length === 0) {
  //   return <div>Loading...</div>;
  // }

  if (error) {
    return <div>Error: {error}</div>;
  }
  return (
    <>
      <SEO
        title={seoTitle}
        description={seoDescription}
        image={community?.avatar_url}
        type="website"
      />
      <div className='p-3'>
        <ClaimRewardBanner />
        {communityHeader}
        {(showInputTag && user == "alejos7ven") && (
          <div className='tag-selector-content'>
            <Input
              type="text"
              className='tag-selector-input fancy-input w-auto'
              placeholder="Set a tag"
              // value=
              onChange={handleInputTagChange}
            // onKeyDown={(e) => e.key === 'Enter' && handleCustomTagSubmit()}
            />
            <button className="btn btn-default  ml-2"
              onClick={handleCustomTagSubmit}
            >
              Set
            </button>
          </div>
        )}
        {!community && (
          <div className="col-12 mb-3">
            Sort: <select
              className='videos-sort-input'
              defaultValue={activeTab}
              onChange={(e) => {
                const value = e.target.value;

                if (value === 'foryou') {
                  navigate(tag ? `/foryou/${tag}` : '/foryou');
                }

                if (value === 'created') {
                  navigate(tag ? `/new/${tag}` : '/new');
                }

                if (value === 'trending') {
                  navigate(tag ? `/trending/${tag}` : '/trending');
                }

                if (value === 'top') {
                  navigate(tag ? `/top/${tag}` : '/top');
                }

                if (value === 'muted') {
                  navigate(tag ? `/muted/${tag}` : '/muted');
                }
              }}
            >
              <option value="foryou">For You ✨</option>
              <option value="created">New</option>
              <option value="trending">Trending</option>
              <option value="top">Top 🔥</option>
              {/* <option value="muted">Muted</option> */}
            </select>

          </div>
        )}

        {(filter == "top" || filter == "alltime") && (
          <div className="menu-tabs mb-2">
            <button className={`tab-button ${filter === 'top' ? 'active' : ''}`} onClick={() => setFilter('top')} title="Latest">
              <i className="fas fa-clock" /> <span className="d-none d-md-inline ml-1">Latest</span>
            </button>
            <button className={`tab-button ${filter === 'alltime' ? 'active' : ''}`} onClick={() => setFilter('alltime')} title="All Time">
              <i className="fas fa-globe" /> <span className="d-none d-md-inline ml-1">All Time</span>
            </button>
          </div>
        )}

        <Row>
          {isLoading && posts.length === 0 && (
            <div className="row w-100 m-0">
              {[1, 2, 3, 4, 5, 6, 7, 8].map(i => (
                <div key={i} className="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 pb-3">
                  <div className="card item-speem" style={{ border: "none" }}>
                    <Skeleton height={180} className="mb-2" />
                    <div className="p-2">
                      <div className="d-flex align-items-center mb-2">
                        <Skeleton circle={true} height={35} width={35} className="mr-2" />
                        <Skeleton width="60%" height={15} />
                      </div>
                      <Skeleton width="90%" height={20} className="mb-1" />
                      <Skeleton width="40%" height={12} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {(posts && posts.length > 0) && (
            <>
              {posts.map((post, index) => {
                if (post.author && post.permlink) {
                  const isPromoted = post.__isPromoted === true;
                  const postUrl = `/@${post.author}/${post.permlink}`;
                  const view = views.find(v => v.url === postUrl);
                  const viewsCount = view ? view.count : 0;
                  const plan = userPlans.find(u => u.username === post.author);
                  let isPlus = plan?.plan_type?.includes("plus") || false;
                  let postData = {
                    ...post,
                    views: viewsCount
                  };
                  return (
                    <React.Fragment key={`${post.id}-${index}`}>
                      {/* Inject Ad every 8 posts or after a promoted post */}
                      {((index > 0 && index % 8 === 0) || (index > 0 && posts[index - 1].__isPromoted)) && (
                        <AdSense type="card" key={`ad-${index}`} />
                      )}
                      <div
                        className="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 pb-3"
                        ref={(node) => {
                          if (index === posts.length - 1) {
                            lastPostElementRef(node);

                          }
                        }}
                      >
                        <PostVideoItem post={postData} userRole={userRole} isPlus={isPlus} isPromoted={isPromoted} />
                      </div>
                    </React.Fragment>
                  );
                }

              })}
            </>
          )}
          {(!isLoading && posts && posts.length == 0) && (
            <div className='col-12 text-center'>No recent videos yet.</div>
          )}
          {loadingMore && <div className='col-12 text-center color-orange'>Loading more videos...</div>}
        </Row>
        <LoginModal
          isShowing={isOpenLoginModal}
          hide={toggleLoginModal}
        />
        <ContentCreatePostModal
          community={community}
          isShowing={isOpenContentCreatePostModal}
          hide={toggleContentCreatePostModal}
        />
        {community && <CommunityInfoModal
          community={community}
          isShowing={isOpenCommunityInfoModal}
          hide={toggleCommunityInfoModal}
        />}

      </div>
    </>
  );
};